import { useEffect, useState } from "react";
import {
  Stack,
  Typography,
  Paper,
  CircularProgress,
  Button,
  Box,
  useMediaQuery,
} from "@mui/material";
import GenerateLinks from "./GenerateLinks";
import report_icon from "../../assets/icons/reports.svg";
import { useNavigate } from "react-router-dom";
import AffiliatedCards from "src/components/AffiliatedCards";
import TruncateText from "src/components/truncate_text/TruncateText";
import eventsAffiliateData from "src/services/events/getAffiliate";
import { useAuthContext } from "src/auth/useAuthContext";
import MobileAffiliatedCards from "src/components/mobileViewAffilitedCards";

const AffiliateLinks = ({ eventData, setEventData, handle }) => {
  const [status, setStatus] = useState(false);
  const matches = useMediaQuery("(max-width:600px)");

  const [affiliationData, setAffiliationData] = useState([]);
  const { user, logout } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await eventsAffiliateData(user, eventData?._id, logout);
      setAffiliationData(response);
    };
    if (eventData?._id) {
      fetchData();
    }
  }, [eventData]);

  return (
    <Stack sx={{ p: 2, border: " 1px solid #E4E5E7", borderRadius: "0.5rem" }}>
      <Stack
        sx={{
          pb: 1,
          justifyContent: "space-between",
          borderBottom: " 1px solid #E4E5E7",
          alignItems: "center",
        }}
        spacing={1.5}
        direction="row"
      >
        <Typography variant="h5">Affiliate Links</Typography>

        <Stack direction="row" alignItems="center">
          {affiliationData?.length > 0 && (
            <Button
              size="small"
              sx={{ p: 0, textAlign: "flex-start" }}
              onClick={() =>
                navigate(`/report-affiliate/`, {
                  state: { data: affiliationData, _id: eventData?._id },
                })
              }
              startIcon={
                <Box
                  component="img"
                  src={report_icon}
                  alt="Share"
                />
              }
            >
              <Typography sx={{ fontWeight: "600" }}>Reports</Typography>
            </Button>
          )}

          {(new Date() < new Date(eventData?.event_end) || eventData?.slots) &&
            eventData?.status &&
            (eventData?.package_data?.some(
              (data) => data?.publish_status === "online"
            ) ||
              eventData?.package_data?.some(
                (data) => data?.publish_status === null
              )) && (
              <GenerateLinks
                eventData={eventData}
                setEventData={setEventData}
                setStatus={setStatus}
                setAffiliationData={setAffiliationData}
              />
            )}
        </Stack>
      </Stack>
      {status ? (
        <Stack
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pt: 2,
          }}
        >
          <CircularProgress />
        </Stack>
      ) : (
        <Stack
          sx={{
            background: " #FFF",
            maxHeight: "16.375rem",
            overflow: "scroll",
            "&::-webkit-scrollbar": {
              width: "2px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "main.primary",
            },
            mt: "1rem",
            pr: "0.75rem",
            overflowX: "hidden",
          }}
        >
          {affiliationData &&
            affiliationData?.length > 0 &&
            affiliationData?.map((item, index) => (
              <Paper
                key={index}
                sx={{
                  width: "100%",
                  border: "1px solid #E4E5E7",
                  p: 1,
                  mt: 1,
                }}
              >
                {matches ? (
                  <>
                    <Stack
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="h5">{item?.user_name}</Typography>
                      {item?.handle && (
                        <TruncateText
                          copyText={
                            item?.short_link ||
                            `${process.env.REACT_FRONT_END_BASE_URL}/events/${item?.handle}`
                          }
                        />
                      )}
                    </Stack>
                    <Paper
                      sx={{
                        width: "100%",
                        border: "1px solid #E4E5E7",
                        p: 1,
                        mt: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          justifyContent: "space-between",
                          // alignItems: "center",
                        }}
                      >
                        <MobileAffiliatedCards
                          count={` ${item?.link_clicks || 0}`}
                          name="Links Clicks"
                        />
                        <MobileAffiliatedCards
                          count={` ${item?.total_tickets || 0}`}
                          name="Total Tickets"
                        />
                        <MobileAffiliatedCards
                          count={` ${item?.total_amt || 0}`}
                          name="Total Amounts"
                        />
                        <MobileAffiliatedCards
                          count={` ${item?.total_entries || 0}/${item?.total_guest || 0
                            }`}
                          name="Total Entries"
                        />
                      </Stack>
                    </Paper>
                  </>
                ) : (
                  <>
                    <Stack
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      direction="row"
                    >
                      <Typography variant="h5">{item?.user_name}</Typography>
                      {item?.handle && (
                        <TruncateText
                          copyText={
                            item?.short_link ||
                            `${process.env.REACT_FRONT_END_BASE_URL}/events/${item?.handle}`
                          }
                        />
                      )}
                    </Stack>
                    <Paper
                      sx={{
                        width: "100%",
                        border: "1px solid #E4E5E7",
                        p: 1,
                        mt: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                        direction="row"
                      >
                        <AffiliatedCards
                          count={` ${item?.link_clicks || 0}`}
                          name="Links Clicks"
                        />
                        <AffiliatedCards
                          count={` ${item?.total_tickets || 0}`}
                          name="Total Tickets"
                        />
                        <AffiliatedCards
                          count={` ${item?.total_amt || 0}`}
                          name="Total Amounts"
                        />
                        <AffiliatedCards
                          count={` ${item?.total_entries || 0}/${item?.total_guest || 0
                            }`}
                          name="Total Entries"
                        />
                      </Stack>
                    </Paper>
                  </>
                )}
              </Paper>
            ))}
        </Stack>
      )}
    </Stack>
  );
};

export default AffiliateLinks;
